import { ApolloClient } from '@apollo/client'
import { AsyncResult, failure, success } from '../../result'
import { ValidateIbanDocument, ValidateIbanMutation, ValidateIbanMutationVariables } from '../../graphql'

const validateIban =
  (client: ApolloClient<unknown>) =>
  async ({ iban }: ValidateIbanMutationVariables): AsyncResult<ValidateIbanMutation['validateIban']> => {
    const result = await client.mutate<ValidateIbanMutation, ValidateIbanMutationVariables>({
      mutation: ValidateIbanDocument,
      variables: {
        iban,
      },
    })

    if (!result.data || !result.data.validateIban) {
      return failure(new Error('No data is being returned from mutation'))
    }

    if (result.data.validateIban.__typename === 'ExpectedErrors') {
      // TODO: Implement some error handling. No idea how
      return failure(new Error('An expected error happened: ' + JSON.stringify(result.data.validateIban.errors)))
    }

    return success(result.data.validateIban)
  }

export default validateIban
